import React from "react";
import { ModalItem, ButtonItem, TextAreaItem, InputNumberItem } from "../../../../Components/Items";
import InsumosFueraDeListaPU from "./InsumosFueraDeListaPU";

const faltanteDe = (renglon) => Math.max(0, Math.round((renglon.cantidad - renglon.consumido) * 100) / 100);

const ModalConfirmarSolicitarMaterialPU = ({
  visible,
  etapa,
  pendientes,
  insumosPorMatriz,
  cantidadesEditadas,
  cantidadAProducir,
  insumosCargando,
  observaciones,
  loading,
  esAbierta,
  insumosExtra,
  empresaId,
  headersToken,
  onChangeInsumosExtra,
  onChangeObservaciones,
  onChangeCantidadInsumo,
  onChangeCantidadAProducir,
  onCerrar,
  onConfirmar,
}) => (
  <ModalItem
    title="Solicitar material a Almacén"
    visible={visible}
    spinning={loading || insumosCargando}
    onCancel={onCerrar}
    width="65%"
    paddingTop
    footer={null}
  >
    <div style={{ color: "#999", fontSize: 12, marginBottom: 12 }}>
      Se pedirá a Almacén lo que falta de cada matriz de la etapa <b>{etapa?.nombre}</b>.{" "}
      {esAbierta ? "La lista es abierta: puedes pedir de más y agregar insumos fuera de lista." : "La lista es cerrada: no puedes pedir más de lo que falta."}
    </div>

    <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 16 }}>
      <span style={{ fontWeight: 600 }}>Cantidad a producir</span>
      <InputNumberItem
        style={{ width: 120 }}
        min={0}
        max={esAbierta ? undefined : Math.max(0, ...(pendientes || []).map(faltanteDe))}
        value={cantidadAProducir}
        onChange={(valor) => onChangeCantidadAProducir(valor)}
      />
      <span style={{ color: "#999", fontSize: 12 }}>
        {esAbierta
          ? "Aplica a todas las matrices de golpe. También puedes ajustar cada insumo por separado abajo."
          : "Aplica a todas las matrices de golpe (topada al faltante real de cada una). También puedes ajustar cada insumo por separado abajo."}
      </span>
    </div>

    {(pendientes || []).map((renglon, index) => {
      const insumos = insumosPorMatriz?.[renglon.matrizId] || [];
      return (
        <div key={index} style={{ marginBottom: 18 }}>
          <div style={{ display: "flex", justifyContent: "space-between", fontSize: 13, fontWeight: 600, marginBottom: 6 }}>
            <span>{renglon.matrizNombre}</span>
            <span style={{ color: "#999", fontWeight: 400 }}>{faltanteDe(renglon)} piezas</span>
          </div>
          <table className="table table-12px">
            {insumos.length > 0 && (
              <thead>
                <tr>
                  <th className="th-border" style={{ width: "45%" }}>
                    Insumo
                  </th>
                  <th className="th-border" style={{ width: "12%" }}>
                    Unidad
                  </th>
                  <th className="th-border" style={{ width: "16%" }}>
                    Por 1 pieza
                  </th>
                  <th className="th-border" style={{ width: "16%" }}>
                    En el proyecto
                  </th>
                  <th className="th-border" style={{ width: "16%" }}>
                    Cantidad a pedir
                  </th>
                </tr>
              </thead>
            )}
            <tbody>
              {insumos.length === 0 ? (
                <tr>
                  <td className="td-border" colSpan="5" style={{ textAlign: "center", color: "#999" }}>
                    <p style={{ margin: 5 }}>Sin insumos</p>
                  </td>
                </tr>
              ) : (
                insumos.map((insumo) => (
                  <tr key={insumo.insumoId}>
                    <td className="td-border" style={{ textAlign: "left" }}>
                      <p style={{ margin: 5 }}>
                        {insumo.clave ? insumo.clave + " - " : ""}
                        {insumo.descripcion}
                      </p>
                    </td>
                    <td className="td-border" style={{ textAlign: "center" }}>
                      <p style={{ margin: 5 }}>{insumo.unidad}</p>
                    </td>
                    <td className="td-border" style={{ textAlign: "right" }}>
                      <p style={{ margin: 5 }}>{insumo.cantidadPorPieza}</p>
                    </td>
                    <td className="td-border" style={{ textAlign: "right" }}>
                      <p style={{ margin: 5 }}>{insumo.inventarioProyecto}</p>
                    </td>
                    <td className="td-border" style={{ padding: 0 }}>
                      <InputNumberItem
                        sinBorde
                        style={{ width: "100%" }}
                        min={0}
                        value={cantidadesEditadas?.[renglon.matrizId]?.[insumo.insumoId] ?? 0}
                        onChange={(valor) => onChangeCantidadInsumo(renglon.matrizId, insumo.insumoId, valor)}
                      />
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      );
    })}

    {esAbierta && (
      <InsumosFueraDeListaPU empresaId={empresaId} headersToken={headersToken} insumos={insumosExtra} onChange={onChangeInsumosExtra} />
    )}

    <div style={{ marginTop: 14, marginBottom: 4, fontWeight: 600 }}>Observaciones (opcional)</div>
    <TextAreaItem placeholder="Opcional" value={observaciones} onChange={(e) => onChangeObservaciones(e.target.value)} />

    <div style={{ textAlign: "right", marginTop: 16 }}>
      <ButtonItem style={{ marginRight: 8 }} onClick={onCerrar}>
        Cancelar
      </ButtonItem>
      <ButtonItem type="primary" mostaza onClick={onConfirmar}>
        Enviar solicitud
      </ButtonItem>
    </div>
  </ModalItem>
);

export default ModalConfirmarSolicitarMaterialPU;
